import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import VideoCard from "../Atomics/VideoCard/VideoCard";
import { useState, useEffect } from "react";
import { playlistFetcher } from "../../api/requests";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { Container } from "react-bootstrap";

const PlaylistVideos = () => {
  const [videos, setVideos] = useState();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const getVideos = async () => {
    setIsLoading(true);
    try {
      const res = await playlistFetcher.getEachPlaylist(id);
      setVideos(res);
    } catch (err) {
      console.error("Failed to fetch playlist videos:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getVideos();
  }, [id]);

  return (
    <ContentWrapper>
      <Container fluid className="pb-0">
        <div
          className="video-block section-padding"
          style={{
            // maxWidth: "1500px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col md={12}>
              <SectionHeader heading="ویدئوها" />
            </Col>
 
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "300px" }}
              >
                <Spinner animation="border" role="status" />
              </div>
            ) : videos?.play_list_videos?.length > 0 ? (
              videos.play_list_videos.map((item, index) => (
                <Col xl={2} sm={4} className="mb-3" key={index}>
                  <VideoCard
                    imgSrc={item.cover ? item.cover : "/img/v4.png"}
                    time={item.duration}
                    videoTitle={item.title}
                    videoCategory={item.categorys?.name}
                    views={item.counted_views}
                    timeAgo={item.published_date}
                    channelName={item.channel?.name}
                    channelId={item.channel?.id}
                    verified
                    imgHref={`/video-page/${item.id}/`}
                    iconHref={`/video-page/${item.id}/`}
                    videoTitleHref={`/video-page/${item.id}/`}
                  />
                </Col>
              ))
            ) : (
              <div className="mr-3">ویدئو ای وجود ندارد.</div>
            )}
          </Row>
        </div>
      </Container>
    </ContentWrapper>
  );
};

export default PlaylistVideos;
